import { useEffect, useRef, useState } from 'react';
import type { WatchQueryFetchPolicy } from '@apollo/client';

export const POLLING_FETCH_POLICY: {
  fetchPolicy: WatchQueryFetchPolicy;
} = { fetchPolicy: 'network-only' };

function usePolling(active: boolean, failed: boolean, processing: boolean, pollingInterval: number): number {
  const interval = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => () => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  }, []);

  const generating = active && !failed && processing;

  const [polling, setPolling] = useState(0);

  useEffect(() => {
    if (generating) {
      if (!interval.current) interval.current = setInterval(() => setPolling((prev) => (prev || 0) + 1), pollingInterval);
    } else if (interval.current) {
      setPolling(0);
      clearInterval(interval.current);
      interval.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generating]); // ignoring `pollingInterval` changes

  // eslint-disable-next-line no-nested-ternary
  return generating
    ? polling + 1
    : failed ? -1 : 0;
}

export default usePolling;
